import WidgetCard from '../../component/instance/widget';
import { BackupCardFilter, BackupStats } from './backupUtils';

interface Props {
    stats: BackupStats;
    loading: boolean;
    filter: BackupCardFilter;
    onFilterChange: (filter: BackupCardFilter) => void;
}

function BackupStatCards({ stats, loading, filter, onFilterChange }: Props) {
    // WidgetCard parses a string value as a number, so text goes in as nodes.
    const percent = stats.databases ? Math.round(stats.backedUp / stats.databases * 100) : undefined;

    // A card with databases to show toggles the chain to just those databases.
    const toggle = (card: Exclude<BackupCardFilter, null>, count: number) => count > 0
        ? () => onFilterChange(filter === card ? null : card)
        : undefined;

    return <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-4">
        <WidgetCard name="Databases backed up" iconClassName="changes" icon="fa-box-archive"
                    value={<>{stats.backedUp} / {stats.databases}</>} loading={loading}
                    onClick={toggle('backedup', stats.backedUp)} active={filter === 'backedup'}
                    cardTooltipText="Databases with at least one full or differential backup. An availability group database counts once. Click to show them"/>
        <WidgetCard name="Databases not backed up" iconClassName="processor" icon="fa-circle-xmark"
                    value={stats.notBackedUp} loading={loading}
                    onClick={toggle('never', stats.notBackedUp)} active={filter === 'never'}
                    cardTooltipText="Databases with no full or differential backup. An availability group database counts once. Click to show them"/>
        <WidgetCard name="Backup coverage" iconClassName="memory" icon="fa-percent"
                    value={percent ?? <>-</>} type="percent" loading={loading}
                    cardTooltipText="The percentage of databases that have been backed up"/>
        <WidgetCard name="Needs attention" iconClassName="io" icon="fa-triangle-exclamation"
                    value={stats.needsAttention} loading={loading}
                    onClick={toggle('attention', stats.needsAttention)} active={filter === 'attention'}
                    cardTooltipText="Databases that have never been backed up, have a failed backup, a broken backup chain or chain warning, or no log backups although the recovery model needs them. Click to show them"/>
    </div>;
}

export default BackupStatCards;
